// Keep a prefix of the ordered icons, reserving space for the overflow label on row two.
export function fitIcons(widths, width, gap, moreWidth, hasMore = false) {
  const fits = (items) => {
    let rows = 1
    let used = 0
    for (const size of items) {
      if (size > width) return false
      const next = used ? used + gap + size : size
      if (next > width) {
        rows += 1
        used = size
      } else {
        used = next
      }
    }
    return rows <= 2
  }

  if (!hasMore && fits(widths)) return { count: widths.length, more: false }

  let count = widths.length
  while (count > 0 && !fits([...widths.slice(0, count), moreWidth])) count -= 1
  return { count, more: true }
}
